import { useCallback } from 'react';

import { DRAFT_TOV_ID } from 'src/data/toneOfVoice';
import { useProjectActions } from 'src/store';

import { useEvents } from './useEvents';

export const useHandlers = ({ generationTool, onSelect, onChange }) => {
  const projectActions = useProjectActions();
  const { trackClickedToneOfVoice } = useEvents(generationTool);

  const handleTovMenuOpen = useCallback(
    (event) => {
      event?.stopPropagation();
      projectActions.openToneOfVoiceMenu();
      trackClickedToneOfVoice();
    },
    [projectActions, trackClickedToneOfVoice]
  );

  const handleTovMenuClose = useCallback(
    (event) => {
      event?.stopPropagation();
      projectActions.closeToneOfVoiceMenu();
    },
    [projectActions]
  );

  const handleSelectToneOfVoice = useCallback(
    (result) => {
      if (!result) {
        return;
      }

      const { tov, customModelId, draftToneOfVoice } = result;
      if (draftToneOfVoice) {
        if (onSelect) {
          onSelect({
            selectedTov: DRAFT_TOV_ID,
            selectedCustomModelId: null,
            draftToneOfVoice: { ...draftToneOfVoice, name: '' },
          });
        } else {
          projectActions.selectDraftToneOfVoice();
        }
      } else if (customModelId) {
        if (onSelect) {
          onSelect({
            generationCustomModelId: customModelId,
          });
        } else {
          projectActions.setSelectedCustomModelId(customModelId);
        }
      } else if (tov) {
        if (onSelect) {
          onSelect({
            selectedTov: tov,
          });
        } else {
          projectActions.updateToneOfVoice(tov);
        }
      }

      handleTovMenuClose();
      onChange?.();
    },
    [handleTovMenuClose, onChange, onSelect, projectActions]
  );

  return {
    handleTovMenuOpen,
    handleTovMenuClose,
    handleSelectToneOfVoice,
  };
};
